<template>
  <div class="card-520-wrapper">

    <div class="card-520-header text-center">
      <div class="card-520-img-wrapper">

        <img :src="image" :alt="alt" class=" card-520-img" alt="">
      </div>
    </div>
    <div class="card-520-body text-center">

      <div class="card-520-title ">
        <slot name="p-1">title</slot>
      </div>
      <div class="card-520-caption">
        <slot name="p-2">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Expedita, voluptatibus!</slot>
      </div>
      <div class="card-520-button ">

          <div class="caption ">
          <slot name="p-3">اطلاعات بیشتر</slot>
          </div>
          <i class="bi bi-arrow-left mt-1"></i>

      </div>


    </div>

  </div>
</template>

<script>
import mA from '../Tags/A'
import mImg from '../Tags/Img'
import {CardProps} from "./CardProps";

export default {
  name: "Card520",
  components: {
    mA,
    mImg,
  },
  props: {
    ...CardProps
  },
}

</script>

<style scoped>
.card-520-wrapper{
  cursor: pointer;


}

.card-520-img-wrapper {



}

.card-520-img {
  object-fit: cover;
  border-radius: 16px;
  height: 200px;
  width: 100%;
  margin-bottom: 32px;
  outline: 2px solid #fff;
  transition: 0.2s ease-in-out;

}

.card-520-title {
  font-size: 22px;
  line-height: 34px;
  margin-bottom: 24px;

}

.card-520-caption {
  font-size: 15px;
  line-height: 30px;
  color: #666666;
  text-align: center;
  min-height: 90px;
  margin-bottom: 5px;
  padding: 0 5px;

}

.card-520-button{
  font-size: 16px;
  line-height: 25px;
  color: #666666;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-bottom: 15px;
  transition: 0.2s ease-in-out;


}

.card-520-wrapper:hover{

  .card-520-button{

    color: var(--primary);
    transition:  0.2s ease-in-out;

  }

  .card-520-img{
    transition: 0.2s ease-in-out;
    outline-offset: -7px;
    -webkit-box-shadow: 0px 18px 92px -29px var(--primary);
    -moz-box-shadow: 0px 18px 92px -29px var(--primary);
    box-shadow: 0px 18px 92px -29px var(--primary);

  }



}





</style>